import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const ordersApi = {
  getOrder: (orderIdOrNumber) => {
    // If it's a number without leading zeros, treat as order number for search
    // Otherwise use as order ID
    const isOrderNumber = /^\d+$/.test(orderIdOrNumber) && orderIdOrNumber.length < 10;
    
    if (isOrderNumber) {
      return apiClient.get(`/orders/search/${orderIdOrNumber}`);
    }
    return apiClient.get(`/orders/${orderIdOrNumber}`);
  },
};

export const paymentPlansApi = {
  list: (params) => apiClient.get('/payment-plans', { params }),
  create: (data) => apiClient.post('/payment-plans', data),
  getById: (id) => apiClient.get(`/payment-plans/${id}`),
  getByOrder: (orderId) => apiClient.get(`/payment-plans/by-order/${orderId}`),
  edit: (id, data) => apiClient.put(`/payment-plans/${id}/edit`, data),
  delete: (id) => apiClient.delete(`/payment-plans/${id}`),
  reconcile: (planId) => apiClient.post(`/reconciliation/plan/${planId}`),
  retryEcommerceSync: (planId) => apiClient.post(`/ecommerce/retry/${planId}`),
};

export const paymentLinksApi = {
  create: (data) => apiClient.post('/payment-links', data),
};

export const conciliationApi = {
  getOrderConciliation: (orderId) => apiClient.get(`/conciliation/orders/${orderId}`),
  getTransactionConciliation: (ipagPaymentId) => 
    apiClient.get(`/conciliation/transactions/${ipagPaymentId}`),
};

export const installmentSettingsApi = {
  getActive: () => apiClient.get('/admin/installment-settings/active'),
};

export default apiClient;
